/** vendor */
import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'

/** lib */
import { fetchCommunityRecipe } from '../../services/recipe.service'
import { useToast } from '../../hooks/useToast'

/** components */
import { Card } from '../../components/UI/Card'
import Loading from '../../components/UI/Loading'
import RecipeDetail from '../../components/Recipes/RecipeDetail'
import IngredientsDropdown from '../../components/UI/IngredientsDropdown'
import OptionDialog from '../../components/Dialogs/OptionDialog'


export default function CommunityRecipe() {
    const location = useLocation()
    const dispatch = useDispatch()

    // a9 utils
    const toast = useToast()

    // ui states
    const [showOptions, setShowOptions] = useState(false)
    const [communityRecipe, setCommunityRecipe] = useState(false)

    const community_recipe_id = location.pathname.split('/')[2]
    const [loading, setLoading] = useState(false)

    /**
     * Hooks
     */
    const init = async () => {
        setLoading(true)

        try {
            const recipe = await fetchCommunityRecipe(community_recipe_id)
            console.warn('recipe', recipe)
            setCommunityRecipe(recipe)
            setLoading(false)
        } catch (error) {
            console.error(error)
            setLoading(false)
        }
    }

    useEffect(() => {
        if(community_recipe_id) {
            init()
        }
    }, [community_recipe_id])

    /**
     * Handlers
     */
    const handleShowOptions = () => {
        setShowOptions(true)
    }

    const handleOnOptionSelect = (action, id) => {
        if (action === 'share') {
            if ('clipboard' in navigator) {
                navigator.clipboard.writeText(window.location.href)
                toast.open(`Copied Link to Clipboard`)
                return
            } 

            const element = document.createElement("textarea")

            element.value = window.location.href
            document.body.appendChild(element)
            element.select();
            document.execCommand("copy")
            document.body.removeChild(element)
            
            toast.open(`Copied to Link Clipboard`)
        }

        if (action === 'print') {

            if(window?.print) {
                window.print()
            }

        }

        if (action === 'clipboard') {
            const ingredients = [...communityRecipe?.ingredients].map(i => {
                return `${i?.name}`
            })
            
            const text = ingredients.join('\r\n')

            if ('clipboard' in navigator) {
                navigator.clipboard.writeText(text)
                toast.open(`Copied Ingredients to Clipboard`)
                return
            } 

            const element = document.createElement("textarea")

            element.value = text
            document.body.appendChild(element)
            element.select();
            document.execCommand("copy")
            document.body.removeChild(element)
            
            toast.open(`Copied Ingredients to Clipboard`)
        } 
    }

    return (
        <div className="pt-12 min-w-full">
            <Card 
                title={communityRecipe?.name}
                status={
                    <button
                        className="text-xs h-6 w-6 text-an_white rounded-full"
                        onClick={ (e) => { handleShowOptions() } }
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z" />
                        </svg>
                    </button>
                }    
            >
                {
                    loading && <div className="h-[60vh] relative pt-40"><Loading /></div>
                }

                {
                    !loading && communityRecipe &&
                        <div 
                            className="min-w-full flex overflow-y-auto justify-center card-no-footer p-2" 
                        >
                            <RecipeDetail recipe={communityRecipe} />
                        </div>
                }
            </Card>

            <IngredientsDropdown ingredients={communityRecipe?.ingredients} />

            <OptionDialog
                processing={false}
                options={[
                    { id: 'shop', label: 'send ingredients to list', disabled: true},
                    { id: 'plan', label: 'send recipe to mealplan', disabled: true},
                    { id: 'print', label: 'print recipe', disabled: true},
                    { id: 'clipboard', label: 'copy ingredients'},
                    { id: 'share', label: 'copy link'},
                ]}
                title={`Recipe Options`}
                onSelect={handleOnOptionSelect} 
                showDialog={showOptions}
                onCancel={ () => { setShowOptions(false) } } 
            />
        </div>
    )
}